import { z } from "zod";
import {
	prepareX7MachineData,
	type MachineCorrugateTrackWithTolerance,
	type X7Machine,
	type X7MachineRequest,
	x7MachineSchema,
} from "@packsize/schemas/machines";

import { emptyGuid } from "@/constants";
import { packNetAxios } from "@/lib/api-client";

import { baseRoutes } from "../base-routes";

export async function createX7Machine(data: X7MachineRequest): Promise<void> {
	await packNetAxios.post(`${baseRoutes.x7}/api/v1/machines`, data);
}

export async function updateX7Machine(tenantId: string, machineId: string, data: X7MachineRequest): Promise<void> {
	// TODO @eb: Remove machineId and tenantId from the payload when the backend no longer requires it.
	await packNetAxios.put(`${baseRoutes.x7}/api/v1/machines/${machineId}`, {
		id: machineId,
		tenantId,
		...data,
	});
}

export async function getX7Machines(): Promise<X7Machine[]> {
	const response = await packNetAxios.get(`${baseRoutes.x7}/api/v1/machines`);

	if (Array.isArray(response.data) === false) {
		throw new Error("Unable to fetch X7 machines, response is not a list");
	}

	return z
		.array(x7MachineSchema)
		.enrich({ callSite: "getX7Machines - v2" })
		.parseWithTelemetry(response.data.map(prepareX7MachineData));
}

export async function getX7Machine(machineId: string): Promise<X7Machine | null> {
	const response = await packNetAxios.get(`${baseRoutes.x7}/api/v1/machines/${machineId}`);

	if (response.status !== 200) {
		return null;
	}

	return x7MachineSchema
		.enrich({ callSite: "getX7Machine - v2" })
		.parseWithTelemetry(prepareX7MachineData(response.data));
}

export async function updateX7Tracks(machineId: string, tracks: MachineCorrugateTrackWithTolerance[]): Promise<void> {
	await packNetAxios.put(`${baseRoutes.x7}/api/v1/machines/${machineId}/corrugates`, {
		corrugates: tracks.map((track) => ({
			trackNumber: track.number,
			loadedCorrugate: track.assignedMaterial.id === emptyGuid ? null : track.assignedMaterial,
		})),
	});
}
